interface Props {
  [key: string]: any
}

function ChevronRightIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 9 16" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M1 1L8 8L1 15"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default ChevronRightIcon
